<section class="dialog-container cws-account-creation-dialogs">
    
    <div mat-dialog-content class="pt-5 pb-5">  
        <div class="with-newlines">Do you want to delete document  [ {{ documentsName }} ]
        </div>
    </div>

    <div mat-dialog-actions class="d-flex justify-content-end border-top pr-4">
        
        <button mat-raised-button class="mat-raised-button mat-primary sg-primary-button ml-2 sg-upload-button" type="button"  (click)="onYesClick()">Yes</button>
        <button class="sg-primary-stroked mat-stroked-button ml-4" (click)="onCloseClick()">No</button>
    </div>
</section>